import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeXml'
})
export class DecodeXmlPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) {
            return value;
        } else {
            value = value.replace(/^<p>/, '');
            value = value.replace(/<\/p>$/, '');
            value = value.replace(/&gt;/g, '>');
            value = value.replace(/&#60;/g, '>');
            value = value.replace(/&lt;/g, '<');
            value = value.replace(/&#62;/g, '<');
            value = value.replace(/&#38;/g, '&');
            value = value.replace(/&#39;/g, '\'');
            value = value.replace(/&#34;/g, '"');
            value = value.replace(/&quot;/g, '"');

            return value; // OK
        }
    }

}
